import React from 'react'
import MaintenancePageUI from './MaintenancePageUI'

const MaintenancePage = () => {
  return <MaintenancePageUI />
}

export default MaintenancePage
